import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import FundraiserSetup from './FundraiserSetup';
import LoadingDots from 'src/assets/loading_dots.svg';

import { fetchDonors, clearDonors } from 'src/redux/donors/donor.action';

import styles from '../index.css';
import theme from 'src/lib/theme';
import { Heading } from 'src/lib/StyledComponents';

class UserSetup extends Component {
	state = {};

	async componentDidMount() {
		// look for an email match and keep data if we find it
		const byEmailResponse = await this.props.fetchDonors({
			'email.address': this.props.currentAuthUser.email,
			$sort: { first: 1 },
			roles: 'fundraiser',
		});

		// as long as there's at least one match by email, save one to show
		if (byEmailResponse.payload.data.length >= 1) {
			this.setState({ matchedFundraiser: { ...byEmailResponse.payload.data[0] } });
		}

		// clearing here resets redux state for the new query (needed for infinite scroll)
		this.props.clearDonors();
		await this.props.fetchDonors({
			roles: 'fundraiser',
			$sort: { first: 1 },
			$skip: this.props.skip,
			$limit: 10,
		});
		this.setState({ ready: true });
	}

	componentWillUnmount() {
		this.props.clearDonors();
	}

	render() {
		if (!this.state.ready) {
			return <LoadingDots className={styles.SetupLoadingDots} />;
		}

		// return to landing page if auth org in wrong state
		if (this.props.authOrganizations[0].setup_state !== 'complete') {
			return <Redirect to={{ pathname: '/' }} />;
		}

		// return to landing page if user is in wrong state
		if (this.props.currentAuthUser.setup_state !== 'needs_bb_id') {
			return <Redirect to={{ pathname: '/' }} />;
		}

		return (
			<div className={styles.SetupCardLayout}>
				<Heading {...theme.heading.setUpTitle}>User Setup</Heading>
				<FundraiserSetup
					matchedFundraiser={this.state.matchedFundraiser}
					fetchDonors={this.props.fetchDonors}
				/>
			</div>
		);
	}
}

const actions = {
	fetchDonors,
	clearDonors,
};

export default UserSetup = connect(() => ({}), actions)(UserSetup);



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Setup/UserSetup/index.js